import { Injectable } from '@angular/core';
import { User } from '../auth/user.model';
import { AuthService } from '../auth/auth.service';
import { GlobalPubSub } from '../shared/global-sub-pub.service';
import { UIService } from '../shared/ui.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    private globalPubSub: GlobalPubSub,
    private uiService: UIService
  ) { }

  getIdentity() {
    const identity = JSON.parse(localStorage.getItem('user'));
    return identity;
  }

  setIdentity(user: User) {
    if (user) {
      const sessionUser = {
        'token' : user.token
      }
      localStorage.setItem('user', JSON.stringify(sessionUser));
      const iOSEvent = {
        'name': 'user_update',
        'user': user
      }
      //this.globalPubSub.fireEvent('fireiOSEvent', iOSEvent);
      this.globalPubSub.fireEvent('updateUserAndToken', user);
    } else {
      localStorage.removeItem('user');
    }
  }

  getPreferredLanguage() {
    const language = JSON.parse(localStorage.getItem('language'));
    return language;
  }

  setPreferredLanguage(language: String) {
    if (language) {
      localStorage.setItem('language', JSON.stringify(language));
    } else {
      localStorage.removeItem('language');
    }
  }

  getPreferredProject() {
    const project = JSON.parse(localStorage.getItem('project'));
    return project;
  }

  setPreferredProject(project: String) {
    if (project) {
      localStorage.setItem('project', JSON.stringify(project));
    } else {
      localStorage.removeItem('project');
    }
    this.uiService.selectedProjectChanged.next(Number(project));
  }
}
